const SESSION_TOKEN_KEY = "homehub.admin.sessionToken";
export const AUTH_SESSION_CHANGED_EVENT = "homehub:auth-session-changed";

export const getSessionToken = (): string | null => {
  return localStorage.getItem(SESSION_TOKEN_KEY);
};

export const setSessionToken = (token: string) => {
  localStorage.setItem(SESSION_TOKEN_KEY, token);
  window.dispatchEvent(new Event(AUTH_SESSION_CHANGED_EVENT));
};

export const clearSessionToken = () => {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  window.dispatchEvent(new Event(AUTH_SESSION_CHANGED_EVENT));
};

export const getAuthHeaders = (): Record<string, string> => {
  const token = getSessionToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const isLoggedIn = (): boolean => {
  return Boolean(getSessionToken());
};
